export const colors = {
  "sp-blue": "#1c95ff",
  "sp-blue-75": "#49aaff", // unused
  "sp-blue-50": "#77bfff",
  "sp-blue-25": "#badfff",
  "zodiac": "#161f6a",
  "zodiac-75": "#454c88", // unused
  "zodiac-50": "#7379a6", // unused
  "zodiac-25": "#b9bbd2", // unused
  "wild-blue": "#878cb2",
  "wild-blue-75": "#9fa3c1", // unused
  "wild-blue-50": "#b7bad1",
  "wild-blue-25": "#dbdce7", // unused
  "orange": "#ff641d",
  "orange-75": "#ff834a", // unused
  "orange-50": "#ffa277", // unused
  "orange-25": "#ffd0bb",
  "forest-green": "#29a34a",
  "forest-green-75": "#54b56e", // unused
  "forest-green-50": "#7fc892", // unused
  "forest-green-25": "#bee3c8", // unused
  "yellow": "#ffc31d",
  "yellow-75": "#ffcf4a", // unused
  "yellow-50": "#ffdb77", // unused
  "yellow-25": "#ffedbb", // unused
  "hoki": "#6880a5",
  "hoki-75": "#8699b7", // unused
  "hoki-50": "#a4b3c9", // unused
  "hoki-25": "#d1d8e4",
  "viola": "#a5689d",
  "viola-75": "#b786b1", // unused
  "viola-50": "#c9a4c4", // unused
  "viola-25": "#e4d1e1", // unused
  "sp-gray": "#ebeef5",
  "sp-gray1": "#e3e5ec",
  "sp-gray2": "#f5f6fa",
};

const fonts = {
  Georgia: "Georgia, serif",
};

export const fontSizes = [12, 14, 16, 18, 24];

export const theme = {
  colors,
  fonts,
  fontSizes,
};
